import { ContextMenu } from '@winnin/winnin_ui.components.context-menu'
import { Icon } from '@winnin/winnin_ui.components.icon'

import './index.scss'

export function DashboardOptionsDropdown({ options }) {
  const handleClick = event => {
    event.preventDefault()
  }

  return (
    <div className="DashboardOptionsDropdown" onClick={handleClick}>
      <ContextMenu menuItems={options}>
        <button className="DashboardOptionsDropdown-button">
          <Icon icon="verticalDots" fill="var(--color_neutral_0)" />
        </button>
      </ContextMenu>
    </div>
  )
}
